import type { Component } from 'vue'

import {
  Aim,
  Connection,
  DataBoard,
  Document,
  Goods,
  Location,
  Lock,
  MagicStick,
  RefreshRight,
  Suitcase,
  Trophy,
  View
} from '@/shared/icons'

interface SidebarNavigationItem {
  routeName: string
  label: string
  icon: Component
  staffOnly?: boolean
}

export const SIDEBAR_NAVIGATION: SidebarNavigationItem[] = [
  {
    routeName: 'websites',
    label: 'Websites',
    icon: Location
  },
  {
    routeName: 'spots',
    label: 'Spots',
    icon: Aim
  },
  {
    routeName: 'traffic-source-presets',
    label: 'Traffic sources',
    icon: Connection
  },
  {
    routeName: 'rotation',
    label: 'Rotation',
    icon: RefreshRight
  },
  {
    routeName: 'offer-restrictions',
    label: 'Offer restrictions',
    icon: Lock
  },
  {
    routeName: 'marketplace',
    label: 'Marketplace',
    icon: Goods
  },
  {
    routeName: 'deals',
    label: 'Deals',
    icon: Suitcase
  },
  {
    routeName: 'media-kits',
    label: 'Mediakits',
    icon: DataBoard
  },
  {
    routeName: 'reports',
    label: 'Reports',
    icon: Document
  }
]

export const SIDEBAR_TOOLS_TITLE = 'Tools'

export const SIDEBAR_TOOLS: SidebarNavigationItem[] = [
  {
    routeName: 'anti_blocks',
    label: 'Anti Ad Block',
    icon: MagicStick
  },
  {
    routeName: 'master-spot-check',
    label: 'Live ad test',
    icon: View,
    staffOnly: true
  }
]

export const SIDEBAR_FOOTER_NAVIGATION: SidebarNavigationItem[] = [
  {
    routeName: 'referrals',
    label: 'Referrals',
    icon: Trophy
  }
]
